import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { JoyrideModule } from 'ngx-joyride';
import { Angulartics2Module } from 'angulartics2';
import { NgbDatepickerModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';

import { WhatsappToggleModule } from '@tablesready/frontend-whatsapp-toggle';
import {
  CommonRadioGroupModule,
  FormValidationModule,
  SearchBarModule,
  SharedTableModule,
  TimepickerModule,
  UtilsModule,
} from '@tablesready/common-ui';
import { PartyCustomFieldsModule } from '@tablesready/frontend-party-custom-fields';
import { IonicModule } from '@ionic/angular';
import { FrontendHeaderModule } from '@tablesready/frontend-header';
import { FrontendIconsModule } from '@tablesready/frontend-icons';
import { FrontendDropdownModule } from '@tablesready/frontend-dropdown';
import { FrontendPullRefreshModule } from '@tablesready/frontend-pull-refresh';
import { FrontendModalModule } from '@tablesready/frontend-modal';
import { BadgeModule } from '@tablesready/frontend-badge';
import { TogoComponent } from './togo.component';
import { TogoRoutingModule } from './togo-routing.module';
import { AddEditTogoModalComponent } from './components';
import { WaitlistActionsModule, WaitlistNotifyModule, WaitlistQuotedTimeModule } from '../components';

@NgModule({
  declarations: [TogoComponent, AddEditTogoModalComponent],
  exports: [TogoComponent],
  imports: [
    CommonModule,
    TogoRoutingModule,
    FrontendIconsModule,
    JoyrideModule,
    SharedTableModule,
    Angulartics2Module,
    CommonRadioGroupModule,
    FormValidationModule,
    FormsModule,
    NgSelectModule,
    NgbDatepickerModule,
    TimepickerModule,
    UtilsModule,
    ReactiveFormsModule,
    SearchBarModule,
    NgbTooltipModule,
    WaitlistActionsModule,
    WaitlistNotifyModule,
    WaitlistQuotedTimeModule,
    WhatsappToggleModule,
    PartyCustomFieldsModule,
    IonicModule,
    FrontendHeaderModule,
    FrontendDropdownModule,
    FrontendPullRefreshModule,
    FrontendModalModule,
    BadgeModule,
  ],
})
export class TogoModule {}
